

export default function Anchor(props) {
   // eslint-disable-next-line
   return <a {...props} />
}